import { useSyncExternalStore } from 'react';
import { getAuthGeneration, subscribeSessionIdentity } from './token';

// Role gates (utils/authUtils) read the committed session snapshot as a plain module value, so
// a component that renders before KeycloakSessionBridge commits sees no roles at all and hides
// role-gated UI. Subscribing here re-renders the consumer on that commit, instead of depending
// on some other hook in the tree happening to subscribe.
//
// Returns the auth generation only so the subscription cannot be dropped as unused; callers
// gate on the authUtils helpers, not on this number.
export const useSessionIdentityGeneration = (): number => useSyncExternalStore(subscribeSessionIdentity, getAuthGeneration, getAuthGeneration);
